import * as backend from 'backend-helpers/memberVirtualGifts';

import { MEMBER_VIRTUAL_GIFT_CHANGE_SUCCESS } from './member';

const MEMBER_VIRTUAL_GIFTS_REQUEST = 'MEMBER_VIRTUAL_GIFTS_REQUEST';
const MEMBER_VIRTUAL_GIFTS_SUCCESS = 'MEMBER_VIRTUAL_GIFTS_SUCCESS';
const MEMBER_VIRTUAL_GIFTS_FAILURE = 'MEMBER_VIRTUAL_GIFTS_FAILURE';

const RECEIVE_MEMBER_VIRTUAL_GIFT = 'RECEIVE_MEMBER_VIRTUAL_GIFT';

const defaultState = {
    offset: 0,
    giftRank: 0,
    giftPoints: 0,
    virtualGifts: [],
    isLoading: false,
    totalCount: null,
};

export default function memberVirtualGifts(state = defaultState, action) {
    switch (action.type) {
        case MEMBER_VIRTUAL_GIFTS_REQUEST:
            return {...state, isLoading: true};
        
        case MEMBER_VIRTUAL_GIFTS_SUCCESS:
            const { giftRank, giftPoints, virtualGifts, offset, totalCount } = action.result.data;
            return {
                offset,
                giftRank,
                giftPoints,
                totalCount,
                isLoading: false,
                virtualGifts: [...state.virtualGifts, ...virtualGifts]
            };
        
        case MEMBER_VIRTUAL_GIFT_CHANGE_SUCCESS:
            return {
                ...state,
                virtualGifts: state.virtualGifts.map((virtualGift) => (
                    virtualGift.id !== action.result.virtualGift.id ? virtualGift : action.result.virtualGift))
            };
        
        case RECEIVE_MEMBER_VIRTUAL_GIFT:
            return {
                ...state,
                giftPoints: state.giftPoints + action.data.points,
                virtualGifts: [ action.data, ...state.virtualGifts ]
            };

        default:
            return state;
    }
}

export const getMemberVirtualGifts = offset => ({
    types: [MEMBER_VIRTUAL_GIFTS_REQUEST, MEMBER_VIRTUAL_GIFTS_SUCCESS, MEMBER_VIRTUAL_GIFTS_FAILURE],
    promise: backend.getMemberVirtualGifts({offset}),
    offset
});

export const receiveMemberVirtualGift = data => ({ type: RECEIVE_MEMBER_VIRTUAL_GIFT, data: data.virtualGifts[0] });


// WEBPACK FOOTER //
// ./src/reducers/memberVirtualGifts.js